import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import Tesseract from "tesseract.js";
import Swal from 'sweetalert2';
import { pdfBeyannameUrl, pdfBeyannameHeaders, downloadPdfBeyannameExcel } from "./pdfBeyannameApi";
import "./FileUpload.css";
import "./ExcelUpload.css";

GlobalWorkerOptions.workerSrc =
  "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js";

const MAX_PDF_BYTES = 25 * 1024 * 1024;

const PROCESS_STEPS = [
  "Dosya Yükleme",
  "PDF Analizi",
  "Veri Ayrıştırma",
  "Excel Raporu Oluşturma",
  "İndirmeye Hazır",
];

const TCI_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/TCI-FH-LOGO.png`;

const PdfAndExcel = () => {
  const [file, setFile] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const [oncekiPdfFile, setOncekiPdfFile] = useState(null);
  const [ocrResult, setOcrResult] = useState("");
  const [brutSatislar, setBrutSatislar] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [isPdfProcessing, setIsPdfProcessing] = useState(false);

  const [bankaValue, setBankaValue] = useState(0);

  const [loading, setLoading] = useState(false);
  const [isProcessed, setIsProcessed] = useState(false);
  const [pdfAnalysisComplete, setPdfAnalysisComplete] = useState(false);
  const [downloadReady, setDownloadReady] = useState(false);
  const [processingError, setProcessingError] = useState(null);
  const [isDraggingOnceki, setIsDraggingOnceki] = useState(false);
  const [isDraggingCari, setIsDraggingCari] = useState(false);
  const oncekiPdfInputRef = useRef(null);
  const pdfInputRef = useRef(null);
  const exportInFlightRef = useRef(false);


 
  const formatNumber = (numberString) => {
    if (!numberString) {
      return "";
    }
    const isNegative = numberString.trim().startsWith("-");

    let cleanedNumber = numberString
      .replace(/\s+/g, "")
      .replace(/[^\d,\.]/g, "");

    cleanedNumber = cleanedNumber.replace(/\./g, "").replace(",", ".");

    return isNegative ? `-${cleanedNumber}` : cleanedNumber;
  };
  const [fileName, setFileName] = useState("");
  const [oncekiFileName, setOncekiFileName] = useState("");
  const [yurticiSatislar, setYurticiSatislar] = useState("");
  const [yurtDisiSatislar, setYurtDisiSatislar] = useState("");
  const [digerGelirler, setDigerGelirler] = useState("");
  const [satisIndirimleri, setSatisIndirimleri] = useState("");
  const [satisIadeleri, setSatisIadeleri] = useState("");
  const [digerIndirimler, setDigerIndirimler] = useState("");
  const [netSatislar, setNetSatislar] = useState("");
  const [satislarinMaliyeti, setSatislarinMaliyeti] = useState("");
  const [satilanTicariMallarinMaliyeti, setSatilanTicariMallarinMaliyeti] =
    useState("");
  const [satilanHizmetMaliyeti, setSatilanHizmetMaliyeti] = useState("");
  const [brutSatisKari, setBrutSatisKari] = useState("");
  const [faaliyetGiderleri, setFaaliyetGiderleri] = useState("");

  const [
    pazarlamaSatisVeDagitimGiderleri,
    setPazarlamaSatisVeDagitimGiderleri,
  ] = useState("");
  const [arastirmaeGelistirmeGiderleri, setArastirmaeGelistirmeGiderleri] =
    useState("");
  const [genelYonetimGiderleri, setGenelYonetimGiderleri] = useState("");
  const [faaliyetKari, setFaaliyetKari] = useState("");
  const [
    digerFaaliyetlerdenOlaganGelirVeKarlar,
    setDigerFaaliyetlerdenOlaganGelirVeKarlar,
  ] = useState("");
  const [faizGelirleri, setFaizGelirleri] = useState("");
  const [menkulKymetSatisKari, setMenkulKymetSatisKari] = useState("");
  const [menkulKymetSatisZarari, setMenkulKymetSatisZarari] = useState("");
  const [kambiyoKarlar, setKambiyoKarlar] = useState("");
  const [digerOlaganGelirVeKarlar, setDigerOlaganGelirVeKarlar] = useState("");
  const [
    digerFaaliyetlerdenOlaganGiderVeZararlar,
    setDigerFaaliyetlerdenOlaganGiderVeZararlar,
  ] = useState("");
  const [karsilikGiderleri, setKarsilikGiderleri] = useState("");
  const [kambiyoZararlar, setKambiyoZararlar] = useState("");
  const [digerOlaganGiderVeZararlar, setDigerOlaganGiderVeZararlar] =
    useState("");
  const [finansmanGiderleri, setFinansmanGiderleri] = useState("");
  const [kisaVadeliBorclanmaGiderleri, setKisaVadeliBorclanmaGiderleri] =
    useState("");
  const [olaganKarVeZarar, setOlaganKarVeZarar] = useState("");
  const [olaganDisiGelirVeKarlar, setOlaganDisiGelirVeKarlar] = useState("");
  const [digerOlagandisiGelirVeKarlar, setDigerOlagandisiGelirVeKarlar] =
    useState("");
  const [olagandisiGiderVeZararlar, setOlagandisiGiderVeZararlar] =
    useState("");
  const [oncekiDonemGiderVeZararlar, setOncekiDonemGiderVeZararlar] =
    useState("");

  const [calismayanKisimGiderVeZararlar, setCalismayanKisimGiderVeZararlar] =
    useState("");

  const [digerOlagandisiGiderVeZararlar, setDigerOlagandisiGiderVeZararlar] =
    useState("");
  const [donemKariVeZarari, setDonemKariVeZarari] = useState("");
  const [
    donemKariVergiVeDiğerYasalYukumluluk,
    setDonemKariVergiVeDiğerYasalYukumluluk,
  ] = useState("");
  const [donemNetKariVeZarari, setDonemNetKariVeZarari] = useState("");
  const [satMamMaliyeti, setSatMamMaliyeti] = useState("");
  const [temettuGelirleri, setTemettuGelirleri] = useState("");
  const [aktifToplam, aktifToplamGelirleri] = useState("");
  const [satisIskontolari, setSatisIskontolari] = useState("");
  const [enflasyonduzetlmeZararlari, setEnflasyonDuzeltmeZararlari] =
    useState(null);

    const [selectedFileName, setSelectedFileName] = useState('Mizan Yükleyiniz ...');

  // Handle Excel file selection
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      
      setFile(selectedFile);
      setSelectedFileName(selectedFile.name)
    }
  };

  const [memzucFile,setMemzucFile] = useState(null)
  const [selectedMemzucFile,setelectedMemzucFile] = useState(null)
 
  const handleMemzucChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      
      setMemzucFile(selectedFile);
      setelectedMemzucFile(selectedFile.name)
    }
  };

  

  
  const validatePdfFile = (selectedPdfFile) => {
    if (!selectedPdfFile) return false;
    if (selectedPdfFile.type !== "application/pdf" && !selectedPdfFile.name.toLowerCase().endsWith(".pdf")) {
      Swal.fire({
        title: "Geçersiz dosya",
        text: "Lütfen yalnızca PDF formatında bir dosya seçin.",
        icon: "warning",
        confirmButtonText: "Tamam",
      });
      return false;
    }
    if (selectedPdfFile.size > MAX_PDF_BYTES) {
      Swal.fire({
        title: "Dosya çok büyük",
        text: "Maksimum dosya boyutu 25 MB olmalıdır.",
        icon: "warning",
        confirmButtonText: "Tamam",
      });
      return false;
    }
    return true;
  };

  const tryStartExport = (nextOnceki, nextCari) => {
    if (!nextCari) return;
    if (!file && !memzucFile) {
      exportPdfToExcel(nextCari, nextOnceki);
    } else if (nextCari) {
      handleProcessPDF(nextCari);
    }
  };

  const selectOncekiPdfFile = (selectedPdfFile) => {
    if (!validatePdfFile(selectedPdfFile)) return;
    setDownloadReady(false);
    setPdfAnalysisComplete(false);
    setProcessingError(null);
    setOncekiPdfFile(selectedPdfFile);
    setOncekiFileName(selectedPdfFile.name);
    tryStartExport(selectedPdfFile, pdfFile);
  };

  const selectPdfFile = (selectedPdfFile) => {
    if (!validatePdfFile(selectedPdfFile)) return;
    setDownloadReady(false);
    setPdfAnalysisComplete(false);
    setProcessingError(null);
    setPdfFile(selectedPdfFile);
    setFileName(selectedPdfFile.name);
    tryStartExport(oncekiPdfFile, selectedPdfFile);
  };

  const exportPdfToExcel = async (uploadedCariFile, uploadedOncekiFile) => {
    const cariToSend = uploadedCariFile || pdfFile;
    const oncekiToSend =
      uploadedOncekiFile !== undefined ? uploadedOncekiFile : oncekiPdfFile;
    if (!cariToSend || exportInFlightRef.current) return;

    exportInFlightRef.current = true;
    setIsUploading(true);
    setLoading(false);
    setDownloadReady(false);
    setProcessingError(null);

    try {
      const pdfFormData = new FormData();
      // Önce önceki dönem (varsa), sonra cari — API sırayla okuyup Excel'e soldan sağa yazar.
      if (oncekiToSend) {
        pdfFormData.append("fileOnceki", oncekiToSend);
      }
      pdfFormData.append("file", cariToSend);

      const response = await fetch(pdfBeyannameUrl("upload"), {
        method: "POST",
        body: pdfFormData,
        headers: pdfBeyannameHeaders({ Accept: "application/json" }),
      });

      if (!response.ok) {
        if (response.status === 401)
          throw new Error("API anahtarı geçersiz veya eksik.");
        throw new Error(`Sunucu hatası (${response.status})`);
      }

      const textResponse = await response.text();
      let data = {};
      try {
        data = textResponse ? JSON.parse(textResponse) : {};
      } catch {
        throw new Error("Sunucudan geçersiz yanıt alındı");
      }

      if (data.excelFilePath) {
        const excelName = data.excelFilePath.split(/[/\\]/).pop();
        await downloadPdfBeyannameExcel(excelName);
        setPdfAnalysisComplete(true);
        setIsProcessed(true);
        setDownloadReady(true);
      } else {
        throw new Error(data.message || "Excel dosyası oluşturulamadı");
      }
    } catch (error) {
      console.error("PDF export hatası:", error);
      const message = error.message || "Excel oluşturulurken bir hata oluştu.";
      setProcessingError(message);
      Swal.fire({
        title: "Hata",
        text: message,
        icon: "error",
        confirmButtonText: "Tamam",
      });
    } finally {
      setIsUploading(false);
      exportInFlightRef.current = false;
    }
  };

  const handleOncekiPdfChange = (e) => {
    const selectedPdfFile = e.target.files[0];
    if (selectedPdfFile) selectOncekiPdfFile(selectedPdfFile);
    e.target.value = "";
  };

  const handlePdfChange = (e) => {
    const selectedPdfFile = e.target.files[0];
    if (selectedPdfFile) selectPdfFile(selectedPdfFile);
    e.target.value = "";
  };

  const handleOncekiDragOver = (e) => {
    e.preventDefault();
    setIsDraggingOnceki(true);
  };

  const handleOncekiDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingOnceki(false);
  };

  const handleOncekiDrop = (e) => {
    e.preventDefault();
    setIsDraggingOnceki(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped) selectOncekiPdfFile(dropped);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggingCari(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDraggingCari(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggingCari(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped) selectPdfFile(dropped);
  };
  const [yil,setYil] = useState("")
  const [donem,setDonem] = useState("")
  const [finalDonem,setFinalDonem] = useState("")
  

  useEffect(() => {
   
  }, [yil]);
  
  useEffect(() => {
    
  }, [donem]);
  useEffect(() => {
  
  }, [finalDonem]);


  

  const handleProcessPDF = async (uploadedFile) => {
    setLoading(true);
    let fullText = "";
    let isTextPdf = true;
    try {
      const pdfData = await uploadedFile.arrayBuffer();
      const pdf = await getDocument({ data: pdfData }).promise;

      for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
        const page = await pdf.getPage(pageNumber);
        const textContent = await page.getTextContent();

        // Sayfa metnini al
        const pageText = textContent.items.map((item) => item.str).join(" ");

        if (pageText.trim().length === 0) {      
       
          isTextPdf = false; 
        } else {
          fullText += pageText + " ";
        }
      }

      if (!isTextPdf) {
        let ocrResults = [];
        for (let pageNumber = 1; pageNumber <= pdf.numPages; pageNumber++) {
          const page = await pdf.getPage(pageNumber);
          const viewport = page.getViewport({ scale: 1.5 });

          // Canvas ile sayfa görüntüsünü çıkar
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: context, viewport }).promise;
          const image = canvas.toDataURL("image/png");

          // OCR ile görüntüyü işle
          const ocrResult = await Tesseract.recognize(image, "tur"); // OCR dilini seçin
          ocrResults.push(ocrResult.data.text);
        }

        // OCR sonuçlarını birleştir ve temizle
        const combinedText = ocrResults.join(" ");
        fullText += combinedText;
      }

      // Sonuçları temizle
      const cleanedText = fullText.replace(/\s+/g, " ").trim();
      setOcrResult(cleanedText);

      const normalizedText = cleanedText;

     



const donemRegex = /\b(Yıllık\s+Yıl\s+(\d{4})|(\d{4})\s+(\d+\.\s*Dönem))\b/;
const donemMatch = normalizedText.match(donemRegex);


if (donemMatch) {
  if (donemMatch[2]) {
    // Yıllık Yıl Durumu
    const yeniYil = donemMatch[2];
    setYil(yeniYil);
    setFinalDonem(`${yeniYil}12`); // Yıl + 12
  } else if (donemMatch[3] && donemMatch[4]) {
    // Dönemli Durum
    const yeniYil = donemMatch[3];
    const yeniDonem = donemMatch[4];

    setYil(yeniYil);
    setDonem(yeniDonem);

    // Dönemlere göre ayarlama
    let donemKodu = "";
    if (yeniDonem === "1. Dönem") donemKodu = "03";
    else if (yeniDonem === "2. Dönem") donemKodu = "06";
    else if (yeniDonem === "3. Dönem") donemKodu = "09";

    setFinalDonem(`${yeniYil}${donemKodu}`); // Yıl + Dönem Kodu
  }
} else {
  console.log("Eşleşme bulunamadı.");
}


const aktifToplamRegex =
/Yurtiçi\s*Satışlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
const aktifToplamMatch = normalizedText.match(aktifToplamRegex);

      if (aktifToplamMatch) {
        const aktifToplamNumbers = aktifToplamMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value = aktifToplamNumbers[aktifToplamNumbers.length - 1];
        aktifToplamGelirleri(value);
      } else {
        console.log("Eşleşme bulunamadı.");
      }

      const satisIskontolariRegex =
        /Satış\s*İskontoları\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const satisIskontolariMatch = normalizedText.match(satisIskontolariRegex);

      if (satisIskontolariMatch) {
        const satisIskontolariNumbers = satisIskontolariMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          satisIskontolariNumbers[satisIskontolariNumbers.length - 1];
        setSatisIskontolari(yurticiSatislarValue);
      }

      const enflasyonDuzeltmeZararlariRegex =
        /Enflasyon\s*Düzeltmesi\s*Zararları\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const enflasyonDuzeltmeZararlariMatch = normalizedText.match(
        enflasyonDuzeltmeZararlariRegex
      );

      if (enflasyonDuzeltmeZararlariMatch) {
        const enflasyonDuzeltmeZararlariNumbers =
          enflasyonDuzeltmeZararlariMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          enflasyonDuzeltmeZararlariNumbers[
            enflasyonDuzeltmeZararlariNumbers.length - 1
          ];
        setEnflasyonDuzeltmeZararlari(value);
      }

      const temettuGelirleriRegex =
        /1.\s*İştiraklerden\s*Temettü\s*Gelirleri\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const temettuGelirleriMatch = normalizedText.match(temettuGelirleriRegex);

      const donemNetKariVeZarariRegex =
        /Dönem\s*Net\s*Karı\s*veya\s*Zararı\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const donemNetKariVeZarariMatch = normalizedText.match(
        donemNetKariVeZarariRegex
      );

      const donemKariVeZarariMatchiRegex =
        /Dönem\s*Karı\s*veya\s*Zararı\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const donemKariVeZarariMatch = normalizedText.match(
        donemKariVeZarariMatchiRegex
      );

      const olağanKarZararRegex =
        /Olağan\s*Kar\s*veya\s*Zarar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const olağanKarZararMatch = normalizedText.match(olağanKarZararRegex);

      const brutSatislarRegex =
        /Brüt\s*Satışlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const brutSatislarMatch = normalizedText.match(brutSatislarRegex);

      const yurticiSatislarRegex =
        /Yurtiçi\s*Satışlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;

      const yurticiSatislarMatch = normalizedText.match(yurticiSatislarRegex);

      if (yurticiSatislarMatch) {
        const yurticiSatislarNumbers = yurticiSatislarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          yurticiSatislarNumbers[yurticiSatislarNumbers.length - 1];
        setYurticiSatislar(yurticiSatislarValue);
      } else {
        console.log("Eşleşme bulunamadı.");
      }

      const yurtDisiSatislarRegex =
        /Yurtdışı\s*Satışlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const yurtDisiSatislarMatch = normalizedText.match(yurtDisiSatislarRegex);

      if (yurtDisiSatislarMatch) {
        const yurtDisiSatislarNumbers = yurtDisiSatislarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          yurtDisiSatislarNumbers[yurtDisiSatislarNumbers.length - 1];
        setYurtDisiSatislar(yurticiSatislarValue);
      } else {
      }

      const satisIadeleriRegex =
        /Satıştan\s*İadeler\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const satisIadeleriMatch = normalizedText.match(satisIadeleriRegex);

      const digerIndirimlerRegex =
        /Diğer\s*İndirimler\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerIndirimlerMatch = normalizedText.match(digerIndirimlerRegex);

      const netSatislarRegex =
        /Net\s*Satışlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const netSatislarMatch = normalizedText.match(netSatislarRegex);

      const satislarinMaliyetiRegex =
        /Satışların\s*Maliyeti\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const satislarinMaliyetiMatch = normalizedText.match(
        satislarinMaliyetiRegex
      );

      const satilanTicariMallarinMaliyetiRegex =
        /Satılan\s*Ticari\s*Mallar\s*Maliyeti\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const satilanTicariMallarinMaliyetiMatch = normalizedText.match(
        satilanTicariMallarinMaliyetiRegex
      );

      const satilanHizmetMaliyetiRegex =
        /Satılan\s*Hizmet\s*Maliyeti\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const satilanHizmetMaliyetiMatch = normalizedText.match(
        satilanHizmetMaliyetiRegex
      );

      const brutSatisKariRegex =
        /Brüt\s*Satış\s*Karı\s*veya\s*Zararı\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const brutSatisKariMatch = normalizedText.match(brutSatisKariRegex);

      const faaliyetGiderleriRegex =
        /Faaliyet\s*Giderleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const faaliyetGiderleriMatch = normalizedText.match(
        faaliyetGiderleriRegex
      );

      const pazarlamaSatisVeDagitimGiderleriRegex =
        /Pazarlama,\s*Satış\s*ve\s*Dağıtım\s*Giderleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const pazarlamaSatisVeDagitimGiderleriMatch = normalizedText.match(
        pazarlamaSatisVeDagitimGiderleriRegex
      );

      const arastirmaveGelistirmeGiderleriRegex =
        /1.\s*Araştırma\s*ve\s*Geliştirme\s*Giderleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const arastirmaveGelistirmeGiderleriMatch = normalizedText.match(
        arastirmaveGelistirmeGiderleriRegex
      );

      const genelYonetimGiderleriRegex =
        /Genel\s*Yönetim\s*Giderleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const genelYonetimGiderleriMatch = normalizedText.match(
        genelYonetimGiderleriRegex
      );

      const faaliyetKariRegex =
        /Faaliyet\s*Karı\s*veya\s*Zararı\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const faaliyetKariMatch = normalizedText.match(faaliyetKariRegex);

      const digerFaaliyetlerdenOlaganGelirVeKarlarRegex =
        /Diğer\s*Faaliyetlerden\s*Olağan\s*Gelir\s*ve\s*Karlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerFaaliyetlerdenOlaganGelirVeKarlarMatch = normalizedText.match(
        digerFaaliyetlerdenOlaganGelirVeKarlarRegex
      );

      const faizGelirleriRegex =
        /Faiz\s*Gelirleri\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const faizGelirleriMatch = normalizedText.match(faizGelirleriRegex);

      const menkulKymetSatisKariRegex =
        /Menkul\s*Kıymet\s*Satış\s*Karları\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const menkulKymetSatisKariMatch = normalizedText.match(
        menkulKymetSatisKariRegex
      );

      // Menkul Kıymet Satış Zararları (-)

      const kambiyoKarlarRegex =
        /Kambiyo\s*Karları\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const kambiyoKarlarMatch = normalizedText.match(kambiyoKarlarRegex);

      const digerOlaganGelirVeKarlarRegex =
        /Diğer\s*Olağan\s*Gelir\s*ve\s*Karlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerOlaganGelirVeKarlarMatch = normalizedText.match(
        digerOlaganGelirVeKarlarRegex
      );

      const digerFaaliyetlerdenOlaganGiderVeZararlarRegex =
        /Diğer\s*Faaliyetlerden\s*Olağan\s*Gider\s*ve\s*Zararlar\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerFaaliyetlerdenOlaganGiderVeZararlarMatch =
        normalizedText.match(digerFaaliyetlerdenOlaganGiderVeZararlarRegex);

      const menkulKymetSatisZarariRegex =
        /3.\s*Menkul\s*Kıymet\s*Satış\s*Zararları\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const menkulKymetSatisZararMatch = normalizedText.match(
        menkulKymetSatisZarariRegex
      );
      const karsilikGiderleriRegex =
        /Karşılık\s*Giderleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const karsilikGiderleriMatch = normalizedText.match(
        karsilikGiderleriRegex
      );

      const kambiyoZararlarRegex =
        /Kambiyo\s*Zararları\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const kambiyoZararlarMatch = normalizedText.match(kambiyoZararlarRegex);

      const digerOlaganGiderVeZararlarRegex =
        /Diğer\s*Olağan\s*Gider\s*ve\s*Zararlar\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerOlaganGiderVeZararlarMatch = normalizedText.match(
        digerOlaganGiderVeZararlarRegex
      );

      const finansmanGiderleriRegex =
        /Finansman\s*Giderleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const finansmanGiderleriMatch = normalizedText.match(
        finansmanGiderleriRegex
      );

      const kisaVadeliBorclanmaGiderleriRegex =
        /Kısa\s*Vadeli\s*Borçlanma\s*Giderleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const kisaVadeliBorclanmaGiderleriMatch = normalizedText.match(
        kisaVadeliBorclanmaGiderleriRegex
      );

      const olaganDisiGelirVeKarlarRegex =
        /Olağan\s*Dışı\s*Gelir\s*ve\s*Karlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const olaganDisiGelirVeKarlarMatch = normalizedText.match(
        olaganDisiGelirVeKarlarRegex
      );

      const digerOlagandisiGelirVeKarlarRegex =
        /Diğer\s*Olağandışı\s*Gelir\s*ve\s*Karlar\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerOlagandisiGelirVeKarlarMatch = normalizedText.match(
        digerOlagandisiGelirVeKarlarRegex
      );

      const olagandisiGiderVeZararlarRegex =
        /Olağandışı\s*Gider\s*ve\s*Zararlar\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const olagandisiGiderVeZararlarMatch = normalizedText.match(
        olagandisiGiderVeZararlarRegex
      );

      const oncekiDonemGiderVeZararlarRegex =
        /Önceki\s*Dönem\s*Gider\s*ve\s*Zararları\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const oncekiDonemGiderVeZararlarMatch = normalizedText.match(
        oncekiDonemGiderVeZararlarRegex
      );

      const calismayanKisimgiderveZararlarRegex =
        /Çalışmayan\s*Kısım\s*Gider\s*ve\s*Zararları\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const calismayanKisimgiderveZararlarMatch = normalizedText.match(
        calismayanKisimgiderveZararlarRegex
      );

      const digerOlagandisiGiderVeZararlarRegex =
        /Diğer\s*Olağandışı\s*Gider\s*ve\s*Zararlar\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerOlagandisiGiderVeZararlarMatch = normalizedText.match(
        digerOlagandisiGiderVeZararlarRegex
      );

      if (brutSatislarMatch) {
        const brutSatislarNumbers = brutSatislarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          brutSatislarNumbers[brutSatislarNumbers.length - 1];
        setBrutSatislar(yurticiSatislarValue);
      }

      const satMamMaliyetiRegex =
        /Satılan\s*Mamuller\s*Maliyeti\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const satMamMaliyetiMatch = normalizedText.match(satMamMaliyetiRegex);

      if (satMamMaliyetiMatch) {
        const satMamMaliyetiNumbers = satMamMaliyetiMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        // Her zaman son sayıyı seç
        const satMamMaliyetiValue =
          satMamMaliyetiNumbers[satMamMaliyetiNumbers.length - 1];

        setSatMamMaliyeti(satMamMaliyetiValue);
      } else {
        console.log("Eşleşme bulunamadı.");
      }

      if (temettuGelirleriMatch) {
        const temettuGelirleriNumbers = temettuGelirleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          temettuGelirleriNumbers[temettuGelirleriNumbers.length - 1];
        setTemettuGelirleri(yurticiSatislarValue);
      }
      const digerGelirlerRegex =
        /Diğer\s*Gelirler\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const digerGelirlerMatch = normalizedText.match(digerGelirlerRegex);

      if (digerGelirlerMatch) {
        const digerGelirlerNumbers = digerGelirlerMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        // Her zaman son sayıyı seç
        const digerGelirlerValue =
          digerGelirlerNumbers[digerGelirlerNumbers.length - 1];

        setDigerGelirler(digerGelirlerValue);
      } else {
        console.log("Eşleşme bulunamadı.");
      }

      const satisIndirimleriRegex =
        /Satış\s*İndirimleri\s*\(-\)\s*((?:-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?(?:\s+)?)+)(?!\.\s*\d+)/;
      const satisIndirimleriMatch = normalizedText.match(satisIndirimleriRegex);

      if (satisIndirimleriMatch) {
        const satisIndirimleriNumbers = satisIndirimleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        // Her zaman son sayıyı seç
        const satisIndirimleriValue =
          satisIndirimleriNumbers[satisIndirimleriNumbers.length - 1];

        setSatisIndirimleri(satisIndirimleriValue);
      } else {
        console.log("Eşleşme bulunamadı.");
      }

      if (satisIadeleriMatch) {
        const satisIadeleriNumbers = satisIadeleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          satisIadeleriNumbers[satisIadeleriNumbers.length - 1];
        setSatisIadeleri(yurticiSatislarValue);
      }

      if (digerIndirimlerMatch) {
        const digerIndirimlerNumbers = digerIndirimlerMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          digerIndirimlerNumbers[digerIndirimlerNumbers.length - 1];
        setDigerIndirimler(yurticiSatislarValue);
      } else {
      }

      if (netSatislarMatch) {
        const netSatislarNumbers = netSatislarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          netSatislarNumbers[netSatislarNumbers.length - 1];

        setNetSatislar(yurticiSatislarValue);
      } else {
      }

      if (satislarinMaliyetiMatch) {
        const satisMaliyetiNumbers = satislarinMaliyetiMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          satisMaliyetiNumbers[satisMaliyetiNumbers.length - 1];
        setSatislarinMaliyeti(yurticiSatislarValue);
      } else {
      }

      if (satilanTicariMallarinMaliyetiMatch) {
        const ticariMallarMaliyetiNumbers =
          satilanTicariMallarinMaliyetiMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          ticariMallarMaliyetiNumbers[ticariMallarMaliyetiNumbers.length - 1];
        setSatilanTicariMallarinMaliyeti(yurticiSatislarValue);
      } else {
      }

      if (satilanHizmetMaliyetiMatch) {
        const hizmetMaliyetiNumbers = satilanHizmetMaliyetiMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          hizmetMaliyetiNumbers[hizmetMaliyetiNumbers.length - 1];
        setSatilanHizmetMaliyeti(yurticiSatislarValue);
      }
      if (brutSatisKariMatch) {
        const brutSatisKariNumbers = brutSatisKariMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          brutSatisKariNumbers[brutSatisKariNumbers.length - 1];
        setBrutSatisKari(yurticiSatislarValue);
      } else {
      }

      if (faaliyetGiderleriMatch) {
        const faaliyetGiderleriNumbers = faaliyetGiderleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          faaliyetGiderleriNumbers[faaliyetGiderleriNumbers.length - 1];
        setFaaliyetGiderleri(yurticiSatislarValue);
      } else {
      }

      if (pazarlamaSatisVeDagitimGiderleriMatch) {
        const pazarlamaGiderleriNumbers =
          pazarlamaSatisVeDagitimGiderleriMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          pazarlamaGiderleriNumbers[pazarlamaGiderleriNumbers.length - 1];
        setPazarlamaSatisVeDagitimGiderleri(yurticiSatislarValue);
      } else {
      }

      if (arastirmaveGelistirmeGiderleriMatch) {
        const arastirmaveGelistirmeGiderleriNumbers =
          arastirmaveGelistirmeGiderleriMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          arastirmaveGelistirmeGiderleriNumbers[
            arastirmaveGelistirmeGiderleriNumbers.length - 1
          ];
        setArastirmaeGelistirmeGiderleri(yurticiSatislarValue);
      }
      if (genelYonetimGiderleriMatch) {
        const genelYonetimGiderleriNumbers = genelYonetimGiderleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const yurticiSatislarValue =
          genelYonetimGiderleriNumbers[genelYonetimGiderleriNumbers.length - 1];
        setGenelYonetimGiderleri(yurticiSatislarValue);
      }

      if (faaliyetKariMatch) {
        const faaliyetKariNumbers = faaliyetKariMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value = faaliyetKariNumbers[faaliyetKariNumbers.length - 1];
        setFaaliyetKari(value);
      }
      if (digerFaaliyetlerdenOlaganGelirVeKarlarMatch) {
        const digerFaaliyetlerdenOlaganGelirVeKarlarNumbers =
          digerFaaliyetlerdenOlaganGelirVeKarlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          digerFaaliyetlerdenOlaganGelirVeKarlarNumbers[
            digerFaaliyetlerdenOlaganGelirVeKarlarNumbers.length - 1
          ];
        setDigerFaaliyetlerdenOlaganGelirVeKarlar(value);
      } else {
      }

      if (faizGelirleriMatch) {
        const faizGelirleriNumbers = faizGelirleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value = faizGelirleriNumbers[faizGelirleriNumbers.length - 1];
        setFaizGelirleri(value);
      }
      if (menkulKymetSatisKariMatch) {
        const menkulKymetSatisKariNumbers = menkulKymetSatisKariMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          menkulKymetSatisKariNumbers[menkulKymetSatisKariNumbers.length - 1];
        setMenkulKymetSatisKari(value);
      }

      if (menkulKymetSatisZararMatch) {
        const menkulKymetSatisZararNumbers = menkulKymetSatisZararMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          menkulKymetSatisZararNumbers[menkulKymetSatisZararNumbers.length - 1];
        setMenkulKymetSatisZarari(value);
      }
      if (kambiyoKarlarMatch) {
        const kambiyoKarlarNumbers = kambiyoKarlarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value = kambiyoKarlarNumbers[kambiyoKarlarNumbers.length - 1];
        setKambiyoKarlar(value);
      }

      if (digerOlaganGelirVeKarlarMatch) {
        const digerOlaganGelirVeKarlarNumbers = digerOlaganGelirVeKarlarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          digerOlaganGelirVeKarlarNumbers[
            digerOlaganGelirVeKarlarNumbers.length - 1
          ];
        setDigerOlaganGelirVeKarlar(value);
      }

      if (digerFaaliyetlerdenOlaganGiderVeZararlarMatch) {
        const digerFaaliyetlerdenOlaganGiderVeZararlarNumbers =
          digerFaaliyetlerdenOlaganGiderVeZararlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          digerFaaliyetlerdenOlaganGiderVeZararlarNumbers[
            digerFaaliyetlerdenOlaganGiderVeZararlarNumbers.length - 1
          ];
        setDigerFaaliyetlerdenOlaganGiderVeZararlar(value);
      }

      if (karsilikGiderleriMatch) {
        const karsilikGiderleriNumbers = karsilikGiderleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          karsilikGiderleriNumbers[karsilikGiderleriNumbers.length - 1];
        setKarsilikGiderleri(value);
      }

      if (kambiyoZararlarMatch) {
        const kambiyoZararlarNumbers = kambiyoZararlarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value = kambiyoZararlarNumbers[kambiyoZararlarNumbers.length - 1];
        setKambiyoZararlar(value);
      }

      if (digerOlaganGiderVeZararlarMatch) {
        const digerOlaganGiderVeZararlarNumbers =
          digerOlaganGiderVeZararlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          digerOlaganGiderVeZararlarNumbers[
            digerOlaganGiderVeZararlarNumbers.length - 1
          ];
        setDigerOlaganGiderVeZararlar(value);
      } else {
      }

      if (finansmanGiderleriMatch) {
        const finansmanGiderleriNumbers = finansmanGiderleriMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          finansmanGiderleriNumbers[finansmanGiderleriNumbers.length - 1];
        setFinansmanGiderleri(value);
      }

      if (kisaVadeliBorclanmaGiderleriMatch) {
        const kisaVadeliBorclanmaGiderleriNumbers =
          kisaVadeliBorclanmaGiderleriMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          kisaVadeliBorclanmaGiderleriNumbers[
            kisaVadeliBorclanmaGiderleriNumbers.length - 1
          ];
        setKisaVadeliBorclanmaGiderleri(value);
      }

      if (olağanKarZararMatch) {
        const olaganKarVeZararNumbers = olağanKarZararMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          olaganKarVeZararNumbers[olaganKarVeZararNumbers.length - 1];
        setOlaganKarVeZarar(value);
      }

      if (olaganDisiGelirVeKarlarMatch) {
        const olaganDisiGelirVeKarlarNumbers = olaganDisiGelirVeKarlarMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          olaganDisiGelirVeKarlarNumbers[
            olaganDisiGelirVeKarlarNumbers.length - 1
          ];
        setOlaganDisiGelirVeKarlar(value);
      }

      if (digerOlagandisiGelirVeKarlarMatch) {
        const digerOlagandisiGelirVeKarlarNumbers =
          digerOlagandisiGelirVeKarlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          digerOlagandisiGelirVeKarlarNumbers[
            digerOlagandisiGelirVeKarlarNumbers.length - 1
          ];
        setDigerOlagandisiGelirVeKarlar(value);
      }

      if (olagandisiGiderVeZararlarMatch) {
        const olagandisiGiderVeZararlarNumbers =
          olagandisiGiderVeZararlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          olagandisiGiderVeZararlarNumbers[
            olagandisiGiderVeZararlarNumbers.length - 1
          ];
        setOlagandisiGiderVeZararlar(value);
      }

      if (oncekiDonemGiderVeZararlarMatch) {
        const oncekiDonemGiderVeZararlarNumbers =
          oncekiDonemGiderVeZararlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          oncekiDonemGiderVeZararlarNumbers[
            oncekiDonemGiderVeZararlarNumbers.length - 1
          ];
        setOncekiDonemGiderVeZararlar(value);
      }

      if (calismayanKisimgiderveZararlarMatch) {
        const calismayanKisimgiderveZararlarNumbers =
          calismayanKisimgiderveZararlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          calismayanKisimgiderveZararlarNumbers[
            calismayanKisimgiderveZararlarNumbers.length - 1
          ];
        setCalismayanKisimGiderVeZararlar(value);
      }

      if (digerOlagandisiGiderVeZararlarMatch) {
        const digerOlagandisiGiderVeZararlarNumbers =
          digerOlagandisiGiderVeZararlarMatch[1]
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları boşluklarla ayır
            .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          digerOlagandisiGiderVeZararlarNumbers[
            digerOlagandisiGiderVeZararlarNumbers.length - 1
          ];
        setDigerOlagandisiGiderVeZararlar(value);
      }

      if (donemKariVeZarariMatch) {
        const donemKariVeZarariNumbers = donemKariVeZarariMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          donemKariVeZarariNumbers[donemKariVeZarariNumbers.length - 1];
        setDonemKariVeZarari(value);
      }

      const donemKariVergiVeDiğerYasalYukumlulukRegex =
        /Dönem\s*Karı,\s*Vergi\s*ve\s*Diğer\s*Yasal\s*Yükümlülük[^0-9]*((-?\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?)(?:\s+(\d{1,3}(?:[\.,]\d{3})*(?:,\d+)?))*)/;

      const donemKariVergiVeDiğerYasalYukumlulukMatch = cleanedText.match(
        donemKariVergiVeDiğerYasalYukumlulukRegex
      );

      if (donemKariVergiVeDiğerYasalYukumlulukMatch) {
        const donemKariVergiNumbers =
          donemKariVergiVeDiğerYasalYukumlulukMatch[0]
            .replace(/[^\d,\.\s-]/g, "") // Sadece sayı ve noktalama işaretlerini bırak
            .trim() // Fazla boşlukları temizle
            .split(/\s+/) // Sayıları ayır
            .filter((item) => /^-?\d/.test(item)); // Sadece sayıları seç

        // Her zaman son sayıyı al
        const donemKariVergiValue =
          donemKariVergiNumbers[donemKariVergiNumbers.length - 1];
        setDonemKariVergiVeDiğerYasalYukumluluk(donemKariVergiValue);
          } else {
        console.log("Eşleşme bulunamadı.");
      }

      if (donemNetKariVeZarariMatch) {
        const donemNetKariVeZarariNumbers = donemNetKariVeZarariMatch[1]
          .trim() // Fazla boşlukları temizle
          .split(/\s+/) // Sayıları boşluklarla ayır
          .filter((item) => /\d/.test(item)); // Sadece sayı olanları al

        const value =
          donemNetKariVeZarariNumbers[donemNetKariVeZarariNumbers.length - 1];
        setDonemNetKariVeZarari(value);
      }

      setIsProcessed(true);
      setPdfAnalysisComplete(true);
    } catch (error) {
      console.error("PDF okunurken hata oluştu:", error);
      setOcrResult("Hata oluştu.");
      setBankaValue("");
      setProcessingError("PDF okunurken hata oluştu.");
    } finally {
      setLoading(false);
    }
  };

  const brutSatislarDecimal = parseFloat(
    formatNumber(brutSatislar).replace(",", ".")
  );
  const yurticiSatislarDecimal = parseFloat(
    formatNumber(yurticiSatislar).replace(",", ".")
  );
  const yurtDisiSatislarDecimal = parseFloat(
    formatNumber(yurtDisiSatislar).replace(",", ".")
  );
  const digerGelirlerDecimal = parseFloat(
    formatNumber(digerGelirler).replace(",", ".")
  );
  const satisIndirimleriDecimal = parseFloat(
    formatNumber(satisIndirimleri).replace(",", ".")
  );
  const satMamMaliyetiDecimal = parseFloat(
    formatNumber(satMamMaliyeti).replace(",", ".")
  );
  const temettuGelirleriDecimal = parseFloat(
    formatNumber(temettuGelirleri).replace(",", ".")
  );
  const satisIadeleriDecimal = parseFloat(
    formatNumber(satisIadeleri).replace(",", ".")
  );
  const digerIndirimlerDecimal = parseFloat(
    formatNumber(digerIndirimler).replace(",", ".")
  );
  const enflasyonDuzeltmeZararlarDecimal = parseFloat(
    formatNumber(enflasyonduzetlmeZararlari).replace(",", ".")
  );

  const netSatislarDecimal = parseFloat(
    formatNumber(netSatislar).replace(",", ".")
  );
  const satislarinMaliyetiDecimal = parseFloat(
    formatNumber(satislarinMaliyeti).replace(",", ".")
  );
  const satilanTicariMallarinMaliyetiDecimal = parseFloat(
    formatNumber(satilanTicariMallarinMaliyeti).replace(",", ".")
  );
  const satilanHizmetMaliyetiDecimal = parseFloat(
    formatNumber(satilanHizmetMaliyeti).replace(",", ".")
  );
  const brutSatisKariDecimal = parseFloat(
    formatNumber(brutSatisKari).replace(",", ".")
  );
  const faaliyetGiderleriDecimal = parseFloat(
    formatNumber(faaliyetGiderleri).replace(",", ".")
  );
  const pazarlamaSatisVeDagitimGiderleriDecimal = parseFloat(
    formatNumber(pazarlamaSatisVeDagitimGiderleri).replace(",", ".")
  );
  const arastirmaeGelistirmeGiderleriDecimal = parseFloat(
    formatNumber(arastirmaeGelistirmeGiderleri).replace(",", ".")
  );
  const genelYonetimGiderleriDecimal = parseFloat(
    formatNumber(genelYonetimGiderleri).replace(",", ".")
  );
  const faaliyetKariDecimal = parseFloat(
    formatNumber(faaliyetKari).replace(",", ".")
  );
  const digerFaaliyetlerdenOlaganGelirVeKarlarDecimal = parseFloat(
    formatNumber(digerFaaliyetlerdenOlaganGelirVeKarlar).replace(",", ".")
  );

  const menkulKymetSatisKariDecimal = parseFloat(
    formatNumber(menkulKymetSatisKari).replace(",", ".")
  );

  const faizGelirleriDecimal = parseFloat(
    formatNumber(faizGelirleri).replace(",", ".")
  );

  const menkulKymetSatisZarariDecimal = parseFloat(
    formatNumber(menkulKymetSatisZarari).replace(",", ".")
  );

  const kambiyoKarlarDecimal = parseFloat(
    formatNumber(kambiyoKarlar).replace(",", ".")
  );

  const digerOlaganGelirVeKarlarDecimal = parseFloat(
    formatNumber(digerOlaganGelirVeKarlar).replace(",", ".")
  );

  const digerFaaliyetlerdenOlaganGiderVeZararlarDecimal = parseFloat(
    formatNumber(digerFaaliyetlerdenOlaganGiderVeZararlar).replace(",", ".")
  );

  const karsilikGiderleriDecimal = parseFloat(
    formatNumber(karsilikGiderleri).replace(",", ".")
  );

  const kambiyoZararlarDecimal = parseFloat(
    formatNumber(kambiyoZararlar).replace(",", ".")
  );

  const digerOlaganGiderVeZararlarDecimal = parseFloat(
    formatNumber(digerOlaganGiderVeZararlar).replace(",", ".")
  );

  const finansmanGiderleriDecimal = parseFloat(
    formatNumber(finansmanGiderleri).replace(",", ".")
  );

  const kisaVadeliBorclanmaGiderleriDecimal = parseFloat(
    formatNumber(kisaVadeliBorclanmaGiderleri).replace(",", ".")
  );

  const olaganKarVeZararDecimal = parseFloat(
    formatNumber(olaganKarVeZarar).replace(",", ".")
  );

  const olaganDisiGelirVeKarlarDecimal = parseFloat(
    formatNumber(olaganDisiGelirVeKarlar).replace(",", ".")
  );

  const digerOlagandisiGelirVeKarlarDecimal = parseFloat(
    formatNumber(digerOlagandisiGelirVeKarlar).replace(",", ".")
  );

  const olagandisiGiderVeZararlarDecimal = parseFloat(
    formatNumber(olagandisiGiderVeZararlar).replace(",", ".")
  );

  const oncekiDonemGiderVeZararlarDecimal = parseFloat(
    formatNumber(oncekiDonemGiderVeZararlar).replace(",", ".")
  );

  const calismayanKisimGiderVeZararDecimal = parseFloat(
    formatNumber(calismayanKisimGiderVeZararlar).replace(",", ".")
  );
  const digerOlagandisiGiderVeZararlarDecimal = parseFloat(
    formatNumber(digerOlagandisiGiderVeZararlar).replace(",", ".")
  );
  const donemKariVergiVeDiğerYasalYukumlulukDecimal = parseFloat(
    formatNumber(donemKariVergiVeDiğerYasalYukumluluk).replace(",", ".")
  );
  const donemNetKariVeZarariDecimal = parseFloat(
    formatNumber(donemNetKariVeZarari).replace(",", ".")
  );
  const donemKariVeZarariDecimal = parseFloat(
    formatNumber(donemKariVeZarari).replace(",", ".")
  );
  const satisIskontolariiDecimal = parseFloat(
    formatNumber(satisIskontolari).replace(",", ".")
  );

  const kz = [
    [
      1,
      "Brüt Satışlar",
      { v: isNaN(brutSatislarDecimal) ? 0 : brutSatislarDecimal, t: "n" },
    ],
    [
      600,
      "1. Yurtiçi Satışlar",
      {
        v: isNaN(yurticiSatislarDecimal) ? 0 : yurticiSatislarDecimal,
        t: "n",
      },
    ],
    [
      601,
      "2. Yurtdışı Satışlar",
      {
        v: isNaN(yurtDisiSatislarDecimal) ? 0 : yurtDisiSatislarDecimal,
        t: "n",
      },
    ],
    [
      602,
      "3. Diğer Gelirler",
      { v: isNaN(digerGelirlerDecimal) ? 0 : digerGelirlerDecimal, t: "n" },
    ],
    [
      "...",
      "A. Brüt Satışlar",
      { v: isNaN(brutSatislarDecimal) ? 0 : brutSatislarDecimal, t: "n" },
    ],
    [
      610,
      "1. Satıştan İadeler (-)",
      { v: isNaN(satisIadeleriDecimal) ? 0 : satisIadeleriDecimal, t: "n" },
    ],
    [
      611,
      "2. Satış İskontoları (-)",
      {
        v: isNaN(satisIskontolariiDecimal) ? 0 : satisIskontolariiDecimal,
        t: "n",
      },
    ],

    [
      612,
      "3. Diğer İndirimler (-)",
      {
        v: isNaN(digerIndirimlerDecimal) ? 0 : digerIndirimlerDecimal,
        t: "n",
      },
    ],
    [
      61,
      "B. Satış İndirimleri (-)",
      {
        v: isNaN(satisIndirimleriDecimal) ? 0 : satisIndirimleriDecimal,
        t: "n",
      },
    ],
    [
      "...",
      "NET SATI�?LAR",
      { v: isNaN(netSatislarDecimal) ? 0 : netSatislarDecimal, t: "n" },
    ],
    [
      620,
      "1. Satılan Mamuller Maliyeti (-)",
      { v: isNaN(satMamMaliyetiDecimal) ? 0 : satMamMaliyetiDecimal, t: "n" },
    ],
    [
      621,
      "2. Satılan Ticari Mallar Maliyeti (-)",
      {
        v: isNaN(satilanTicariMallarinMaliyetiDecimal)
          ? 0
          : satilanTicariMallarinMaliyetiDecimal,
        t: "n",
      },
    ],
    [
      622,
      "3. Satılan Hizmet Maliyeti (-)",
      {
        v: isNaN(satilanHizmetMaliyetiDecimal)
          ? 0
          : satilanHizmetMaliyetiDecimal,
        t: "n",
      },
    ],
    [623, "4. Diğer Satışların Maliyeti (-)", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [
      62,
      "D. Satışların Maliyeti (-)",
      {
        v: isNaN(satislarinMaliyetiDecimal) ? 0 : satislarinMaliyetiDecimal,
        t: "n",
      },
    ],
    [
      "...",
      "BRÜT SATI�? KAR VEYA ZARARI",
      { v: isNaN(brutSatisKariDecimal) ? 0 : brutSatisKariDecimal, t: "n" },
    ],
    [
      630,
      "1. Araştırma ve Geliştirme Giderleri (-)",
      {
        v: isNaN(arastirmaeGelistirmeGiderleriDecimal)
          ? 0
          : arastirmaeGelistirmeGiderleriDecimal,
        t: "n",
      },
    ],
    [
      631,
      "2. Pazarlama, Satış ve Dağıtım Giderleri (-)",
      {
        v: isNaN(pazarlamaSatisVeDagitimGiderleriDecimal)
          ? 0
          : pazarlamaSatisVeDagitimGiderleriDecimal,
        t: "n",
      },
    ],
    [
      632,
      "3. Genel Yönetim Giderleri (-)",
      {
        v: isNaN(genelYonetimGiderleriDecimal)
          ? 0
          : genelYonetimGiderleriDecimal,
        t: "n",
      },
    ],
    [
      63,
      "E. Faaliyet Giderleri (-)",
      {
        v: isNaN(faaliyetGiderleriDecimal) ? 0 : faaliyetGiderleriDecimal,
        t: "n",
      },
    ],
    [
      "...",
      "FAALİYET KAR VEYA ZARARI",
      { v: isNaN(faaliyetKariDecimal) ? 0 : faaliyetKariDecimal, t: "n" },
    ],
    [
      640,
      "1. İştiraklerden Temettü Gelirleri",
      {
        v: isNaN(temettuGelirleriDecimal) ? 0 : temettuGelirleriDecimal,
        t: "n",
      },
    ],
    [
      641,
      "2. Bağlı Ortaklıklardan Temettü Gelirleri",
      { v: isNaN(0) ? 0 : 0, t: "n" },
    ],
    [
      642,
      "3. Faiz Gelirleri",
      { v: isNaN(faizGelirleriDecimal) ? 0 : faizGelirleriDecimal, t: "n" },
    ],
    [643, "4. Komisyon Gelirler", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [644, "5. Konusu Kalmayan Karşılıklar", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [
      645,
      "6. Menkul Kıymet Satış Karları",
      {
        v: isNaN(menkulKymetSatisKariDecimal) ? 0 : menkulKymetSatisKariDecimal,
        t: "n",
      },
    ],
    [
      646,
      "7. Kambiyo Karları",
      { v: isNaN(kambiyoKarlarDecimal) ? 0 : kambiyoKarlarDecimal, t: "n" },
    ],
    [647, "8. Reeskont Faiz Gelirleri", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [648, "9. Enflasyon Düzeltmesi Karları", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [
      649,
      "10. Diğer Olağan Gelir ve Karlar",
      {
        v: isNaN(digerOlaganGelirVeKarlarDecimal)
          ? 0
          : digerOlaganGelirVeKarlarDecimal,
        t: "n",
      },
    ],
    [
      64,
      "F. Diğer Faaliyetlerden Olağan Gelir ve Karlar",
      {
        v: isNaN(digerFaaliyetlerdenOlaganGelirVeKarlarDecimal)
          ? 0
          : digerFaaliyetlerdenOlaganGelirVeKarlarDecimal,
        t: "n",
      },
    ],
    [653, "1. Komisyon Giderleri (-)", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [
      654,
      "2. Karşılık Giderleri (-)",
      {
        v: isNaN(karsilikGiderleriDecimal) ? 0 : karsilikGiderleriDecimal,
        t: "n",
      },
    ],
    [
      655,
      "3. Menkul Kıymet Satış Zararları (-)",
      {
        v: isNaN(menkulKymetSatisZarariDecimal)
          ? 0
          : menkulKymetSatisZarariDecimal,
        t: "n",
      },
    ],
    [
      656,
      "4. Kambiyo Zararları (-)",
      {
        v: isNaN(kambiyoZararlarDecimal) ? 0 : kambiyoZararlarDecimal,
        t: "n",
      },
    ],
    [657, "5. Reeskont Faiz Giderleri (-)", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [
      658,
      "6. Enflasyon Düzeltmesi Zararları (-)",
      {
        v: isNaN(enflasyonDuzeltmeZararlarDecimal)
          ? 0
          : enflasyonDuzeltmeZararlarDecimal,
        t: "n",
      },
    ],
    [
      659,
      "7. Diğer Olağan Gider ve Zararlar (-)",
      {
        v: isNaN(digerOlaganGiderVeZararlarDecimal)
          ? 0
          : digerOlaganGiderVeZararlarDecimal,
        t: "n",
      },
    ],
    [
      65,
      "G. Diğer Faaliyetlerden Olağan Gider ve Zararlar (-)",
      {
        v: isNaN(digerFaaliyetlerdenOlaganGiderVeZararlarDecimal)
          ? 0
          : digerFaaliyetlerdenOlaganGiderVeZararlarDecimal,
        t: "n",
      },
    ],
    [
      660,
      "1. Kısa Vadeli Borçlanma Giderleri (-)",
      {
        v: isNaN(kisaVadeliBorclanmaGiderleriDecimal)
          ? 0
          : kisaVadeliBorclanmaGiderleriDecimal,
        t: "n",
      },
    ],
    [
      661,
      "2. Uzun Vadeli Borçlanma Giderleri (-)",
      { v: isNaN(0) ? 0 : 0, t: "n" },
    ],
    [
      66,
      "H. Finansman Giderleri (-)",
      {
        v: isNaN(finansmanGiderleriDecimal) ? 0 : finansmanGiderleriDecimal,
        t: "n",
      },
    ],
    [
      "...",
      "OLA�?AN KAR VEYA ZARARI",
      {
        v: isNaN(olaganKarVeZararDecimal) ? 0 : olaganKarVeZararDecimal,
        t: "n",
      },
    ],
    [671, "1. Önceki Dönem Gelir ve Karları", { v: isNaN(0) ? 0 : 0, t: "n" }],
    [
      679,
      "2. Diğer Olağandışı Gelir ve Karlar",
      {
        v: isNaN(digerOlagandisiGelirVeKarlarDecimal)
          ? 0
          : digerOlagandisiGelirVeKarlarDecimal,
        t: "n",
      },
    ],

    [
      67,
      "I. Olağan Dışı Gelir ve Karlar",
      {
        v: isNaN(olaganDisiGelirVeKarlarDecimal)
          ? 0
          : olaganDisiGelirVeKarlarDecimal,
        t: "n",
      },
    ],
    [
      680,
      "1. Çalışmayan Kısım Gider ve Zararları (-)",
      {
        v: isNaN(calismayanKisimGiderVeZararDecimal)
          ? 0
          : calismayanKisimGiderVeZararDecimal,
        t: "n",
      },
    ],
    [
      681,
      "2. Önceki Dönem Gider ve Zararları (-)",
      {
        v: isNaN(oncekiDonemGiderVeZararlarDecimal)
          ? 0
          : oncekiDonemGiderVeZararlarDecimal,
        t: "n",
      },
    ],
    [
      689,
      "3. Diğer Olağandışı Gider ve Zararlar (-)",
      {
        v: isNaN(digerOlagandisiGiderVeZararlarDecimal)
          ? 0
          : digerOlagandisiGiderVeZararlarDecimal,
        t: "n",
      },
    ],
    [
      68,
      "J. Olağandışı Gider ve Zararlar (-)",
      {
        v: isNaN(olagandisiGiderVeZararlarDecimal)
          ? 0
          : olagandisiGiderVeZararlarDecimal,
        t: "n",
      },
    ],
    [
      690,
      "690-DÖNEM KARI VEYA ZARARI",
      {
        v: isNaN(donemKariVeZarariDecimal) ? 0 : donemKariVeZarariDecimal,
        t: "n",
      },
    ],
    [
      691,
      "K. Dönem Karı, Vergi ve Diğer Yasal Yükümlülük",
      {
        v: isNaN(donemKariVergiVeDiğerYasalYukumlulukDecimal)
          ? 0
          : donemKariVergiVeDiğerYasalYukumlulukDecimal,
        t: "n",
      },
    ],
    [
      692,
      "692-DÖNEM NET KARI VEYA ZARARI",
      {
        v: isNaN(donemNetKariVeZarariDecimal) ? 0 : donemNetKariVeZarariDecimal,
        t: "n",
      },
    ],
  ];


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading(true);
  
    // SweetAlert2 loading ekranını başlat
    const swalInstance = Swal.fire({
      title: 'Yükleniyor...',
      text: 'Veri işleniyor, lütfen bekleyin.',
      icon: 'info',
      allowOutsideClick: false, // Modal dışında tıklanmasına izin vermez
      didOpen: () => {
        Swal.showLoading(); // Yükleme animasyonunu göster
      },
      // loading süresiyle ilgili süreyi ayarlayabiliriz
      willClose: () => {
        setIsUploading(false); // Modal kapandığında yükleme durumunu sıfırla
      }
    });
  
    try {
      // Eğer Excel veya Memzuç dosyalarından biri yoksa,
      // sadece PDF'i backend'e gönderip Excel üret ve indir.
      if (!file || !memzucFile) {
        swalInstance.close();
        if (pdfFile) {
          await exportPdfToExcel(pdfFile);
        }
        return;
      }

      const formData = new FormData();
      formData.append("excelFile", file);
      formData.append("memzucFile", memzucFile);
      formData.append("kz", JSON.stringify(kz)); // JSON string olarak gönder     
      formData.append("finalDonem", JSON.stringify(finalDonem)); // JSON string olarak gönder  

      if (pdfFile) {
        await handleProcessPDF(pdfFile);
      }
      //  https://ocrservice.tcisigorta.com/upload-excel
      //  Local geliştirme için backend adresi:
      const response = await fetch("http://localhost:5000/upload-excel", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        console.error("Sunucudan gelen cevap hatalı:", response.statusText);
        throw new Error("Sunucudan gelen cevap hatalı");
      }

      const blob = await response.blob();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "updated_output.xlsx";
      link.click();
      setDownloadReady(true);

      swalInstance.close();
    } catch (error) {
      console.error("Yükleme hatası:", error);
      alert("Yükleme sırasında bir hata oluştu.");
  
      // Hata durumunda SweetAlert2 modalını kapat ve hata mesajı göster
      swalInstance.close(); // Hata durumunda da modalı kapatıyoruz
      Swal.fire({
        title: 'Hata!',
        text: 'Yükleme sırasında bir hata oluştu.',
        icon: 'error',
        confirmButtonText: 'Tamam',
      });
    } finally {
      setIsUploading(false); // Yükleme tamamlandıktan sonra
    }
  };

  let activeStep = 0;
  if (downloadReady) activeStep = 4;
  else if (isUploading) activeStep = 3;
  else if (loading) activeStep = 1;
  else if (pdfAnalysisComplete) activeStep = 2;
  else if (pdfFile || oncekiPdfFile) activeStep = 1;

  const getStepState = (index) => {
    if (index < activeStep) return "done";
    if (index === activeStep) return "active";
    return "pending";
  };

  const getStepStatusLabel = (index, state) => {
    if (state === "done") return "Tamamlandı";
    if (state === "active") {
      if (index === 0) return pdfFile || oncekiPdfFile ? "Tamamlandı" : "Hazır";
      if (index === 4 && downloadReady) return "Hazır";
      if (index === 1 && loading) return "İşleniyor...";
      if (index === 1 && processingError) return "Hata";
      if (index === 3 && isUploading) return "İşleniyor...";
      if (index === 1 && pdfAnalysisComplete) return "Tamamlandı";
      if (index === 2 && pdfAnalysisComplete && !isUploading) return "Tamamlandı";
      return "İşleniyor...";
    }
    return "Beklemede";
  };

  const progressPercent = `${(activeStep / 4) * 84}%`;
  const showDownloadBtn =
    pdfFile && !loading && !isUploading && (downloadReady || processingError);

  return (
    <motion.div
      className="bap-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <motion.div
        className="bap-wave"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      />
      <motion.div
        className="bap-brand"
        initial={{ opacity: 0, y: -8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, delay: 0.05 }}
      >
        <img src={TCI_LOGO_SRC} alt="TCI Finansal Hizmetler" className="bap-brand-logo" />
      </motion.div>
      <motion.div
        className="bap-layout"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
      >
        <motion.section
          className="bap-hero"
          initial={{ opacity: 0, x: -24 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <p className="bap-hero-kicker">Beyanname Analiz Platformu</p>
          <h1>Beyanname verilerinizi akıllı teknolojiyle anlamlı içgörülere dönüştürün.</h1>
          <p className="bap-hero-subtitle">
            PDF formatındaki beyanname belgelerinizi sisteme yükleyin; platformumuz
            verilerinizi otomatik olarak analiz ederek düzenli ve yapılandırılmış Excel
            raporlarına dönüştürür.
          </p>
          <ul className="bap-features">
            <li className="bap-feature">
              <span className="bap-feature-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                </svg>
              </span>
              <div>
                <p className="bap-feature-title">Güvenli Veri İşleme</p>
                <p className="bap-feature-desc">
                  Verileriniz gelişmiş güvenlik standartlarıyla korunur ve güvenli şekilde işlenir.
                </p>
              </div>
            </li>
            <li className="bap-feature">
              <span className="bap-feature-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="3" y="3" width="18" height="18" rx="2" />
                  <path d="M3 9h18M9 21V9" />
                </svg>
              </span>
              <div>
                <p className="bap-feature-title">Otomatik Veri Ayrıştırma</p>
                <p className="bap-feature-desc">
                  PDF içerisindeki veriler otomatik olarak analiz edilir ve ilgili alanlara ayrıştırılır.
                </p>
              </div>
            </li>
            <li className="bap-feature">
              <span className="bap-feature-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                </svg>
              </span>
              <div>
                <p className="bap-feature-title">Hızlı ve Güvenilir Sonuçlar</p>
                <p className="bap-feature-desc">
                  Excel raporunuza saniyeler içinde hızlı ve doğru şekilde ulaşın.
                </p>
              </div>
            </li>
            <li className="bap-feature">
              <span className="bap-feature-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
                  <path d="M22 12A10 10 0 0 0 12 2v10z" />
                </svg>
              </span>
              <div>
                <p className="bap-feature-title">Finansal Standartlara Uyum</p>
                <p className="bap-feature-desc">
                  TCI uzmanlığıyla hazırlanan çıktılar, finansal veri standartlarına uygun şekilde oluşturulur.
                </p>
              </div>
            </li>
          </ul>
        </motion.section>

        <motion.form
          onSubmit={handleSubmit}
          className="bap-card"
          initial={{ opacity: 0, x: 24 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <div className="bap-card-header">
            <span className="bap-card-header-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8" />
              </svg>
            </span>
            <div>
              <h2>PDF Beyanname Yükleme</h2>
              <p>Önceki (opsiyonel) + cari dönem PDF’lerini yükleyin.</p>
            </div>
          </div>

          <div className="bap-dropzone-stack">
            <div className="bap-dropzone-block">
              <div className="bap-dropzone-period-row">
                <p className="bap-dropzone-period">Önceki Dönem</p>
                <span className="bap-dropzone-optional">İsteğe bağlı</span>
              </div>
              <motion.div
                className={`bap-dropzone${isDraggingOnceki ? " bap-dropzone--drag" : ""}${oncekiFileName ? " bap-dropzone--filled" : ""}`}
                onDragOver={handleOncekiDragOver}
                onDragLeave={handleOncekiDragLeave}
                onDrop={handleOncekiDrop}
                onClick={() => oncekiPdfInputRef.current?.click()}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") oncekiPdfInputRef.current?.click();
                }}
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.3 }}
                whileHover={{ scale: 1.01 }}
              >
                <motion.div
                  className="bap-dropzone-pdf-icon"
                  aria-hidden="true"
                  animate={{ y: [0, -3, 0] }}
                  transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
                >
                  <svg viewBox="0 0 48 56" fill="none">
                    <path
                      d="M8 0h24l16 16v40a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                      fill="rgba(37,99,235,0.15)"
                      stroke="#3b82f6"
                      strokeWidth="2"
                    />
                    <path d="M32 0v16h16" stroke="#3b82f6" strokeWidth="2" />
                    <text x="14" y="42" fill="#3b82f6" fontSize="14" fontWeight="700" fontFamily="Inter,sans-serif">
                      PDF
                    </text>
                  </svg>
                </motion.div>
                <p className="bap-dropzone-text">
                  {oncekiFileName ? oncekiFileName : "Sürükleyin veya seçin"}
                </p>
                <button
                  type="button"
                  className="bap-btn-select"
                  onClick={(e) => {
                    e.stopPropagation();
                    oncekiPdfInputRef.current?.click();
                  }}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
                  </svg>
                  {oncekiFileName ? "Değiştir" : "Dosya Seç"}
                </button>
                <input
                  ref={oncekiPdfInputRef}
                  id="file-input-onceki"
                  type="file"
                  accept=".pdf,application/pdf"
                  onChange={handleOncekiPdfChange}
                />
              </motion.div>
            </div>

            <div className="bap-dropzone-block">
              <div className="bap-dropzone-period-row">
                <p className="bap-dropzone-period">Cari Dönem</p>
                <span className="bap-dropzone-required">Zorunlu</span>
              </div>
              <motion.div
                className={`bap-dropzone${isDraggingCari ? " bap-dropzone--drag" : ""}${fileName ? " bap-dropzone--filled" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => pdfInputRef.current?.click()}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") pdfInputRef.current?.click();
                }}
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.35 }}
                whileHover={{ scale: 1.01 }}
              >
                <motion.div
                  className="bap-dropzone-pdf-icon"
                  aria-hidden="true"
                  animate={{ y: [0, -3, 0] }}
                  transition={{ duration: 2.5, repeat: Infinity, ease: "easeInOut" }}
                >
                  <svg viewBox="0 0 48 56" fill="none">
                    <path
                      d="M8 0h24l16 16v40a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                      fill="rgba(37,99,235,0.15)"
                      stroke="#3b82f6"
                      strokeWidth="2"
                    />
                    <path d="M32 0v16h16" stroke="#3b82f6" strokeWidth="2" />
                    <text x="14" y="42" fill="#3b82f6" fontSize="14" fontWeight="700" fontFamily="Inter,sans-serif">
                      PDF
                    </text>
                  </svg>
                </motion.div>
                <p className="bap-dropzone-text">
                  {fileName ? fileName : "Sürükleyin veya seçin"}
                </p>
                <button
                  type="button"
                  className="bap-btn-select"
                  onClick={(e) => {
                    e.stopPropagation();
                    pdfInputRef.current?.click();
                  }}
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
                  </svg>
                  {fileName ? "Değiştir" : "Dosya Seç"}
                </button>
                <input
                  ref={pdfInputRef}
                  id="file-input2"
                  type="file"
                  accept=".pdf,application/pdf"
                  onChange={handlePdfChange}
                />
              </motion.div>
            </div>
          </div>

          <motion.div
            className="bap-info-bar"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.45 }}
          >
            <div className="bap-info-item">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <path d="M14 2v6h6" />
              </svg>
              <span className="bap-info-label">Desteklenen format</span>
              <span className="bap-info-value">PDF</span>
            </div>
            <motion.div
              className="bap-info-item"
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.56 }}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </svg>
              <span className="bap-info-label">Ortalama işlem süresi</span>
              <span className="bap-info-value">10–30 saniye</span>
            </motion.div>
          </motion.div>

          <p className="bap-steps-title">İşlem Adımları</p>
          <div className="bap-steps">
            <motion.div
              className="bap-steps-progress"
              initial={{ width: 0 }}
              animate={{ width: progressPercent }}
              transition={{ duration: 0.4 }}
            />
            {PROCESS_STEPS.map((label, index) => {
              const state = getStepState(index);
              return (
                <motion.div
                  key={label}
                  className={`bap-step bap-step--${state}`}
                  initial={{ opacity: 0, y: 8 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.5 + index * 0.06 }}
                >
                  <span className="bap-step-circle">{index + 1}</span>
                  <span className="bap-step-label">{label}</span>
                  <span className="bap-step-status">{getStepStatusLabel(index, state)}</span>
                </motion.div>
              );
            })}
          </div>

          {showDownloadBtn && (
            <motion.div
              className="bap-download-wrap"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              <motion.button
                className="bap-btn-download"
                type={processingError && !downloadReady ? "button" : "submit"}
                disabled={isUploading}
                onClick={
                  processingError && !downloadReady
                    ? () => exportPdfToExcel()
                    : undefined
                }
                whileHover={!isUploading ? { scale: 1.02 } : {}}
                whileTap={!isUploading ? { scale: 0.98 } : {}}
              >
                {isUploading
                  ? "Excel oluşturuluyor..."
                  : downloadReady
                    ? "Excel'i Tekrar İndir"
                    : "Yeniden Dene"}
              </motion.button>
            </motion.div>
          )}

          {(loading || isUploading || isPdfProcessing) && (
            <p className="bap-processing-msg">
              {loading ? "PDF analiz ediliyor..." : "Excel raporu hazırlanıyor..."}
            </p>
          )}
        </motion.form>
      </motion.div>
    </motion.div>
  );
};

export default PdfAndExcel;
